import Header from "../components/Header.jsx";
import Footer from "../components/Footer.jsx";
import Panier from "../components/CartData.jsx";
export default function Cart(){


    return(
        <div>
            <Header />
            <Panier/>
            <Footer />
        </div>
    )
}